module.exports = {
	"description": "London Underground stations, with their lines and Travelcard zones",
	"source": "https://en.wikipedia.org/wiki/List_of_London_Underground_stations",
	"stations": [
		{
			"name": "Acton Town",
			"lines": [
				"District",
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Aldgate",
			"lines": [
				"Metropolitan",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Aldgate East",
			"lines": [
				"Hammersmith & City",
				"District"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Alperton",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Amersham",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				9
			]
		},
		{
			"name": "Angel",
			"lines": [
				"Northern"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Archway",
			"lines": [
				"Northern"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Arnos Grove",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Arsenal",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Baker Street",
			"lines": [
				"Metropolitan",
				"Bakerloo",
				"Circle",
				"Jubilee",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Balham",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Bank",
			"lines": [
				"Waterloo & City",
				"Northern",
				"Central"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Barbican",
			"lines": [
				"Metropolitan",
				"Circle",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Barking",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Barkingside",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Barons Court",
			"lines": [
				"District",
				"Piccadilly"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Bayswater",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Becontree",
			"lines": [
				"District"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Belsize Park",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Bermondsey",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Bethnal Green",
			"lines": [
				"Central"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Blackfriars",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Blackhorse Road",
			"lines": [
				"Victoria"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Bond Street",
			"lines": [
				"Central",
				"Jubilee"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Borough",
			"lines": [
				"Northern"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Boston Manor",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Bounds Green",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				3,
				4
			]
		},
		{
			"name": "Bow Road",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Brent Cross",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Brixton",
			"lines": [
				"Victoria"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Bromley-by-Bow",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Buckhurst Hill",
			"lines": [
				"Central"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Burnt Oak",
			"lines": [
				"Northern"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Caledonian Road",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Camden Town",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Canada Water",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Canary Wharf",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Canning Town",
			"lines": [
				"Jubilee"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Cannon Street",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Canons Park",
			"lines": [
				"Jubilee"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Chalfont & Latimer",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				8
			]
		},
		{
			"name": "Chalk Farm",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Chancery Lane",
			"lines": [
				"Central"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Charing Cross",
			"lines": [
				"Bakerloo",
				"Northern"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Chesham",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				9
			]
		},
		{
			"name": "Chigwell",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Chiswick Park",
			"lines": [
				"District"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Chorleywood",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				7
			]
		},
		{
			"name": "Clapham Common",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Clapham North",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Clapham South",
			"lines": [
				"Northern"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Cockfosters",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Colindale",
			"lines": [
				"Northern"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Colliers Wood",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Covent Garden",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Croxley",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				7
			]
		},
		{
			"name": "Dagenham East",
			"lines": [
				"District"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Dagenham Heathway",
			"lines": [
				"District"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Debden",
			"lines": [
				"Central"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Dollis Hill",
			"lines": [
				"Jubilee"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Ealing Broadway",
			"lines": [
				"District",
				"Central"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Ealing Common",
			"lines": [
				"District",
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Earl's Court",
			"lines": [
				"District",
				"Piccadilly"
			],
			"zones": [
				1,
				2
			]
		},
		{
			"name": "East Acton",
			"lines": [
				"Central"
			],
			"zones": [
				2
			]
		},
		{
			"name": "East Finchley",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "East Ham",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				3,
				4
			]
		},
		{
			"name": "East Putney",
			"lines": [
				"District"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Eastcote",
			"lines": [
				"Metropolitan",
				"Piccadilly"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Edgware",
			"lines": [
				"Northern"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Edgware Road",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Edgware Road",
			"lines": [
				"Hammersmith & City",
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Elephant & Castle",
			"lines": [
				"Northern",
				"Bakerloo"
			],
			"zones": [
				1,
				2
			]
		},
		{
			"name": "Elm Park",
			"lines": [
				"District"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Embankment",
			"lines": [
				"District",
				"Bakerloo",
				"Northern",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Epping",
			"lines": [
				"Central"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Euston",
			"lines": [
				"Northern",
				"Victoria"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Euston Square",
			"lines": [
				"Metropolitan",
				"Circle",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Fairlop",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Farringdon",
			"lines": [
				"Metropolitan",
				"Circle",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Finchley Central",
			"lines": [
				"Northern"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Finchley Road",
			"lines": [
				"Metropolitan",
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Finsbury Park",
			"lines": [
				"Piccadilly",
				"Victoria"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Fulham Broadway",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Gants Hill",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Gloucester Road",
			"lines": [
				"District",
				"Piccadilly",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Golders Green",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Goldhawk Road",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Goodge Street",
			"lines": [
				"Northern"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Grange Hill",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Great Portland Street",
			"lines": [
				"Metropolitan",
				"Circle",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Greenford",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Green Park",
			"lines": [
				"Piccadilly",
				"Victoria",
				"Jubilee"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Gunnersbury",
			"lines": [
				"District"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Hainault",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Hammersmith",
			"lines": [
				"District",
				"Piccadilly"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Hammersmith",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Hampstead",
			"lines": [
				"Northern"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Hanger Lane",
			"lines": [
				"Central"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Harlesden",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Harrow & Wealdstone",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Harrow-on-the-Hill",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Hatton Cross",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				5,
				6
			]
		},
		{
			"name": "Heathrow Terminals 1, 2, 3",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Heathrow Terminal 4",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Heathrow Terminal 5",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Hendon Central",
			"lines": [
				"Northern"
			],
			"zones": [
				3,
				4
			]
		},
		{
			"name": "High Barnet",
			"lines": [
				"Northern"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Highbury & Islington",
			"lines": [
				"Victoria"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Highgate",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "High Street Kensington",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Hillingdon",
			"lines": [
				"Metropolitan",
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Holborn",
			"lines": [
				"Central",
				"Piccadilly"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Holland Park",
			"lines": [
				"Central"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Holloway Road",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Hornchurch",
			"lines": [
				"District"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Hounslow Central",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Hounslow East",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Hounslow West",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Hyde Park Corner",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Ickenham",
			"lines": [
				"Metropolitan",
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Kennington",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Kensal Green",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Kensington (Olympia)",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Kentish Town",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Kenton",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Kew Gardens",
			"lines": [
				"District"
			],
			"zones": [
				3,
				4
			]
		},
		{
			"name": "Kilburn",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Kilburn Park",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Kingsbury",
			"lines": [
				"Jubilee"
			],
			"zones": [
				4
			]
		},
		{
			"name": "King's Cross St. Pancras",
			"lines": [
				"Metropolitan",
				"Northern",
				"Piccadilly",
				"Circle",
				"Victoria",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Knightsbridge",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Ladbroke Grove",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Lambeth North",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Lancaster Gate",
			"lines": [
				"Central"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Latimer Road",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Leicester Square",
			"lines": [
				"Piccadilly",
				"Northern"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Leyton",
			"lines": [
				"Central"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Leytonstone",
			"lines": [
				"Central"
			],
			"zones": [
				3,
				4
			]
		},
		{
			"name": "Liverpool Street",
			"lines": [
				"Metropolitan",
				"Central",
				"Circle",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "London Bridge",
			"lines": [
				"Northern",
				"Jubilee"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Loughton",
			"lines": [
				"Central"
			],
			"zones": [
				6
			]
		},
		{
			"name": " Maida Vale",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Manor House",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Mansion House",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Marble Arch",
			"lines": [
				"Central"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Marylebone",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Mile End",
			"lines": [
				"District",
				"Hammersmith & City",
				"Central"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Mill Hill East",
			"lines": [
				"Northern"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Monument",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Moorgate",
			"lines": [
				"Metropolitan",
				"Northern",
				"Circle",
				"Hammersmith & City"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Moor Park",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				6,
				7
			]
		},
		{
			"name": "Morden",
			"lines": [
				"Northern"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Mornington Crescent",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Neasden",
			"lines": [
				"Jubilee"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Newbury Park",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "North Acton",
			"lines": [
				"Central"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "North Ealing",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "North Greenwich",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "North Harrow",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				5
			]
		},
		{
			"name": "North Wembley",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Northfields",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Northolt",
			"lines": [
				"Central"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Northwick Park",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Northwood",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Northwood Hills",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Notting Hill Gate",
			"lines": [
				"District",
				"Central",
				"Circle"
			],
			"zones": [
				1,
				2
			]
		},
		{
			"name": "Oakwood",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Old Street",
			"lines": [
				"Northern"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Osterley",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Oval",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Oxford Circus",
			"lines": [
				"Central",
				"Bakerloo",
				"Victoria"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Paddington",
			"lines": [
				"Hammersmith & City",
				"District",
				"Circle",
				"Bakerloo"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Park Royal",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Parsons Green",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Perivale",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Piccadilly Circus",
			"lines": [
				"Bakerloo",
				"Piccadilly"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Pimlico",
			"lines": [
				"Victoria"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Pinner",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Plaistow",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Preston Road",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Putney Bridge",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Queen's Park",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Queensbury",
			"lines": [
				"Jubilee"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Queensway",
			"lines": [
				"Central"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Ravenscourt Park",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Rayners Lane",
			"lines": [
				"Metropolitan",
				"Piccadilly"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Redbridge",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Regent's Park",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Richmond",
			"lines": [
				"District"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Rickmansworth",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				7
			]
		},
		{
			"name": "Roding Valley",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Royal Oak",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Ruislip",
			"lines": [
				"Metropolitan",
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Ruislip Gardens",
			"lines": [
				"Central"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Ruislip Manor",
			"lines": [
				"Metropolitan",
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Russell Square",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				1
			]
		},
		{
			"name": "St. James's Park",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "St. John's Wood",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "St. Paul's",
			"lines": [
				"Central"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Seven Sisters",
			"lines": [
				"Victoria"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Shepherd's Bush",
			"lines": [
				"Central"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Shepherd's Bush Market",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Sloane Square",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Snaresbrook",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "South Ealing",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "South Harrow",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				5
			]
		},
		{
			"name": "South Kensington",
			"lines": [
				"District",
				"Piccadilly",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "South Kenton",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				4
			]
		},
		{
			"name": "South Ruislip",
			"lines": [
				"Central"
			],
			"zones": [
				5
			]
		},
		{
			"name": "South Wimbledon",
			"lines": [
				"Northern"
			],
			"zones": [
				3,
				4
			]
		},
		{
			"name": "South Woodford",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Southfields",
			"lines": [
				"District"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Southgate",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Southwark",
			"lines": [
				"Jubilee"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Stamford Brook",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Stanmore",
			"lines": [
				"Jubilee"
			],
			"zones": [
				5
			]
		},
		{
			"name": "Stepney Green",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Stockwell",
			"lines": [
				"Northern",
				"Victoria"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Stonebridge Park",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Stratford",
			"lines": [
				"Central",
				"Jubilee"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Sudbury Hill",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Sudbury Town",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Swiss Cottage",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Temple",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Theydon Bois",
			"lines": [
				"Central"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Tooting Bec",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Tooting Broadway",
			"lines": [
				"Northern"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Tottenham Court Road",
			"lines": [
				"Central",
				"Northern"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Tottenham Hale",
			"lines": [
				"Victoria"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Totteridge & Whetstone",
			"lines": [
				"Northern"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Tower Hill",
			"lines": [
				"District",
				"Circle"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Tufnell Park",
			"lines": [
				"Northern"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Turnham Green",
			"lines": [
				"District",
				"Piccadilly"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Turnpike Lane",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Upminster",
			"lines": [
				"District"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Upminster Bridge",
			"lines": [
				"District"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Upney",
			"lines": [
				"District"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Upton Park",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Uxbridge",
			"lines": [
				"Metropolitan",
				"Piccadilly"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Vauxhall",
			"lines": [
				"Victoria"
			],
			"zones": [
				1,
				2
			]
		},
		{
			"name": "Victoria",
			"lines": [
				"District",
				"Circle",
				"Victoria"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Walthamstow Central",
			"lines": [
				"Victoria"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Wanstead",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Warren Street",
			"lines": [
				"Northern",
				"Victoria"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Warwick Avenue",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Waterloo",
			"lines": [
				"Waterloo & City",
				"Bakerloo",
				"Northern",
				"Jubilee"
			],
			"zones": [
				1
			]
		},
		{
			"name": "Watford",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				7
			]
		},
		{
			"name": "Wembley Central",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Wembley Park",
			"lines": [
				"Metropolitan",
				"Jubilee"
			],
			"zones": [
				4
			]
		},
		{
			"name": "West Acton",
			"lines": [
				"Central"
			],
			"zones": [
				3
			]
		},
		{
			"name": "West Brompton",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "West Finchley",
			"lines": [
				"Northern"
			],
			"zones": [
				4
			]
		},
		{
			"name": "West Ham",
			"lines": [
				"District",
				"Hammersmith & City",
				"Jubilee"
			],
			"zones": [
				3
			]
		},
		{
			"name": "West Hampstead",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2
			]
		},
		{
			"name": "West Harrow",
			"lines": [
				"Metropolitan"
			],
			"zones": [
				5
			]
		},
		{
			"name": "West Kensington",
			"lines": [
				"District"
			],
			"zones": [
				2
			]
		},
		{
			"name": "West Ruislip",
			"lines": [
				"Central"
			],
			"zones": [
				6
			]
		},
		{
			"name": "Westbourne Park",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Westminster",
			"lines": [
				"District",
				"Circle",
				"Jubilee"
			],
			"zones": [
				1
			]
		},
		{
			"name": "White City",
			"lines": [
				"Central"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Whitechapel",
			"lines": [
				"District",
				"Hammersmith & City"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Willesden Green",
			"lines": [
				"Jubilee"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Willesden Junction",
			"lines": [
				"Bakerloo"
			],
			"zones": [
				2,
				3
			]
		},
		{
			"name": "Wimbledon",
			"lines": [
				"District"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Wimbledon Park",
			"lines": [
				"District"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Wood Green",
			"lines": [
				"Piccadilly"
			],
			"zones": [
				3
			]
		},
		{
			"name": "Wood Lane",
			"lines": [
				"Hammersmith & City",
				"Circle"
			],
			"zones": [
				2
			]
		},
		{
			"name": "Woodford",
			"lines": [
				"Central"
			],
			"zones": [
				4
			]
		},
		{
			"name": "Woodside Park",
			"lines": "Northern",
			"zones": [
				4
			]
		}
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/geography/london_underground_stations.json
 **/